<template>
  <v-container fluid class="infor pa-0">
    <v-stepper v-model="e1">
      <v-stepper-header style="background: transparent">
        <v-stepper-step
          flex-colum
          :complete="stepFade > 1"
          :class="[stepFade > 1 ? 'complete-step' : 'inactive-step', stepFade == 1 ? 'active-step' : '']"
          step="1"
        >INFORMATION</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepFade > 2"
          :class="[stepFade > 2 ? 'complete-step' : 'inactive-step', stepFade == 2 ? 'active-step' : '']"
          step="2"
        >RECHERCHE</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="stepFade > 3"
          :class="[stepFade > 3 ? 'complete-step' : 'inactive-step', stepFade == 3 ? 'active-step' : '']"
          step="3"
        >
          <span style="text-transform:uppercase">{{$t('Result')}}</span>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row
            style="overflow-x: auto !important; flex-wrap: inherit;"
            v-dragscroll.x
            class="dragscroll"
          >
            <v-col cols="3" class="col-infor" v-if="stepFade >= 1">
              <h2 class="step_title primary--text">INFORMATION</h2>
              <ValidationObserver ref="form" v-slot="{ validate, reset }">
                <form action>
                  <v-card flat class="mt-0">
                    <v-card-text class="pa-0 mb-1">
                      <v-row>
                        <v-col style="white-space: nowrap;" class="pt-0">
                          <p class="label">Date</p>
                          <v-icon v-text="'$clock'" class="mr-2"></v-icon>
                          {{ formClient.createdAt | moment('DD/MM/YYYY') }}
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-text class="pa-0">
                      <p class="label">Commercial</p>
                      <!-- name -->
                      <ValidationProvider v-slot="{ errors }" :name="$t('Name')" rules="required">
                        <v-text-field
                          outlined
                          hide-details="auto"
                          v-model="formClient.userName"
                          :error-messages="errors"
                          required
                          class="mb-4"
                          :disabled="disabledFirstStep"
                        ></v-text-field>
                      </ValidationProvider>
                      <!-- /name -->
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Expéditeur')"
                        rules="required"
                      >
                        <p class="label">Expéditeur</p>
                        <IdentityPickerInput
                          v-model="formClient.identityId"
                          :disabled="disabledFirstStep"
                          :hide-label="true"
                          :error-messages="errors"
                          ref="IdentityPickerInput"
                        ></IdentityPickerInput>
                      </ValidationProvider>
                      <!-- Client -->
                      <ValidationProvider v-slot="{ errors }" :name="$t('Client')" rules="required">
                        <p class="label">
                          <span>Client</span>
                          <v-btn icon small class="pa-0 icon-right" @click="dialogAddClient = true">
                            <v-icon v-text="'$plus_circle'" color="#47266F"></v-icon>
                          </v-btn>
                        </p>
                        <ClientPickerInput
                          v-model="formClient.clientId"
                          :disabled="disabledFirstStep"
                          :hide-label="true"
                          :error-messages="errors"
                          ref="clientPickerInput"
                          @search-add-new="addNewContact"
                        ></ClientPickerInput>
                      </ValidationProvider>

                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('location')"
                        rules="required"
                      >
                        <div>
                          <p class="label" v-if="formClient.clientId">Identité facturable</p>
                          <v-autocomplete
                            v-if="formClient.clientId"
                            :items="clientLocations"
                            item-text="identity"
                            item-value="id"
                            outlined
                            hide-details="auto"
                            class="mb-4"
                            return-object
                            required
                            :error-messages="errors"
                            v-model="clientLocationDetail"
                            :disabled="disabledFirstStep"
                          >
                            <template slot="append-item">
                              <v-divider></v-divider>
                              <v-btn
                                text
                                block
                                color="#828282"
                                class="text-left"
                                @click="addNewContact"
                              >
                                <em>Ajouter une Identité facturable</em>
                              </v-btn>
                            </template>
                          </v-autocomplete>

                          <v-row class="client-details mb-3" v-if="clientLocationDetail">
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Identité facturable</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientLocationDetail.identity }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Ville</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientLocationDetail.address }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>CP</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientLocationDetail.codePostal }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Adresse</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientLocationDetail.city }}</p>
                            </v-col>

                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Pays</em>
                              </h4>
                              <p
                                class="mb-0 caption"
                              >{{ clientLocationDetail.countryId ? clientLocationDetail.countryId.name : '' }}</p>
                            </v-col>
                          </v-row>
                        </div>
                      </ValidationProvider>

                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('contact')"
                        rules="required"
                      >
                        <div>
                          <p class="label" v-if="formClient.clientId">Contact</p>
                          <v-autocomplete
                            v-if="formClient.clientId"
                            :items="clientContacts"
                            item-text="name"
                            item-value="id"
                            outlined
                            hide-details="auto"
                            class="mb-4"
                            return-object
                            v-model="clientContactDetail"
                            :error-messages="errors"
                            :disabled="disabledFirstStep"
                          >
                            <template slot="append-item">
                              <v-divider></v-divider>
                              <v-btn
                                text
                                block
                                color="#828282"
                                class="text-left"
                                @click="addNewContact"
                              >
                                <em>Ajouter un contact</em>
                              </v-btn>
                            </template>
                          </v-autocomplete>
                          <v-row class="client-details mb-3" v-if="clientContactDetail">
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Nom & Prénom</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientContactDetail.name }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Email</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientContactDetail.email }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Téléphone fix</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientContactDetail.telephone }}</p>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                              <h4 class="black--text pb-1 caption font-weight-bold">
                                <em>Mobile</em>
                              </h4>
                              <p class="mb-0 caption">{{ clientContactDetail.mobile }}</p>
                            </v-col>
                          </v-row>
                        </div>
                      </ValidationProvider>

                      <p class="label">Note</p>
                      <v-textarea
                        v-model="formClient.note"
                        :disabled="disabledFirstStep"
                        outlined
                        name="input-7-4"
                        value
                      ></v-textarea>
                    </v-card-text>
                  </v-card>
                </form>
              </ValidationObserver>
              <v-btn class="btn-step px-2" color="primary" small rounded outlined @click="goStep2">
                Suivant
                <v-icon v-text="'$arrow_next'" small class="ml-1"></v-icon>
              </v-btn>
              <v-btn
                class="btn-step px-2"
                color="primary"
                small
                rounded
                outlined
                @click="backToStep1"
                v-if="stepFade > 1"
              >
                <v-icon v-text="'$arrow_back'" small class="mr-1"></v-icon>Retour
              </v-btn>
            </v-col>

            <div class="col-rech" v-if="stepFade >= 2">
              <h2 class="step_title primary--text">RECHERCHE</h2>
              <v-card flat class="mt-0">
                <div class="d-flex">
                  <div class="pt-0 col-rech-item">
                    <v-card-text class="pa-0 mb-4">
                      <p class="label">Sexe</p>
                      <v-select
                        :items="[{text: 'Femme', value: 0}, {text: 'Homme', value: 1}]"
                        v-model="formSearch.dataSearch.gender"
                        outlined
                        clearable
                        hide-details="auto"
                      ></v-select>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <p class="label">Date de naissance</p>

                      <v-row>
                        <v-col cols="6" class="py-0">
                          <v-select
                            label="de"
                            :items="birthYearSelections"
                            v-model="formSearch.dataSearch.birthYearFrom"
                            clearable
                            outlined
                            class="small-label-outlined"
                            hide-details="auto"
                          ></v-select>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-select
                            label="à"
                            :items="birthYearSelections"
                            v-model="formSearch.dataSearch.birthYearTo"
                            clearable
                            outlined
                            class="small-label-outlined"
                            hide-details="auto"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <NewsletterMultiplePickerInput v-model="formSearch.dataSearch.newsletter" />
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <AlternanceMultiplePickerInput v-model="formSearch.dataSearch.isAlternance" />
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <CountryMultiplePickerInput v-model="formSearch.dataSearch.country"></CountryMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <RegionMultiplePickerInput
                        v-model="formSearch.dataSearch.region"
                        :country-ids="formSearch.dataSearch.country"
                        :task-edit="taskEdit"
                        @resetTask="resetTask"
                      ></RegionMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <DepartmentMultiplePickerInput
                        v-model="formSearch.dataSearch.department"
                        :region-ids="formSearch.dataSearch.region"
                        :task-edit="taskEdit"
                        @resetTask="resetTask"
                      ></DepartmentMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <SourcePickerInput v-model="formSearch.dataSearch.source" />
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <DelegatePickerInput v-model="formSearch.dataSearch.delegate" />
                    </v-card-text>
                  </div>

                  <div
                    class="pt-0 col-rech-item"
                    v-for="(filters, index) in formSearch.dataFilter"
                    :key="index"
                  >
                    <v-card-text class="pa-0 mb-4">
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :nudge-top="-45"
                        transition="scale-transition"
                        bottom
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="de"
                            prepend-icon="event"
                            readonly
                            :value="formatDate(formSearch.dataFilter[index].createdFrom)"
                            v-on="on"
                            clearable
                            @click:clear="formSearch.dataFilter[index].createdFrom = null"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          locale="fr-fr"
                          :min="minDate"
                          :max="maxDate"
                          v-model="formSearch.dataFilter[index].createdFrom"
                          no-title
                          @change="changeFromDate(index)"
                          class="mt-0"
                        ></v-date-picker>
                      </v-menu>
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :nudge-top="-45"
                        transition="scale-transition"
                        bottom
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="à"
                            prepend-icon="event"
                            readonly
                            :value="formatDate(formSearch.dataFilter[index].createdTo)"
                            v-on="on"
                            clearable
                            @click:clear="formSearch.dataFilter[index].createdTo = null"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          locale="fr-fr"
                          :min="minDate"
                          :max="maxDate"
                          v-model="formSearch.dataFilter[index].createdTo"
                          no-title
                          @change="changeToDate(index)"
                          class="mt-0"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                    <v-card-text class="pa-0 mb-4">
                      <YearMultiplePickerInput
                        v-model="formSearch.dataFilter[index].yearBackToSchool"
                        @input="changeYearBackToSchool(index)"
                      ></YearMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <StudyLevelMultiplePickerInput
                        v-model="formSearch.dataFilter[index].studyLevel"
                      ></StudyLevelMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <DiplomaMultiplePickerInput v-model="formSearch.dataFilter[index].diploma"></DiplomaMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <ObtainedSpecialityMultiplePickerInput
                        v-model="formSearch.dataFilter[index].obtainedSpecialities"
                        :diploma-ids="formSearch.dataFilter[index].diploma"
                        :task-edit="taskEdit"
                        @resetTask="resetTask"
                      />
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <ThemeCheckboxInput v-model="formSearch.dataFilter[index].themes"></ThemeCheckboxInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <DegreeTypePickerInput
                        v-model="formSearch.dataFilter[index].degreeTypeId"
                        label="Spécialité(s) envisagée(s) à poursuivre des études ?"
                      ></DegreeTypePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <SpecialityMultiplePickerInput
                        v-model="formSearch.dataFilter[index].objectiveSpecialities"
                        :degree-type-id="formSearch.dataFilter[index].degreeTypeId"
                        :task-edit="taskEdit"
                        @resetTask="resetTask"
                        :hide-label="true"
                      />
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4">
                      <ChannelMultiplePickerInput v-model="formSearch.dataFilter[index].channel"></ChannelMultiplePickerInput>
                    </v-card-text>

                    <v-card-text class="pa-0 mb-4 text-center">
                      <v-btn
                        icon
                        class="px-2"
                        color="#47266f"
                        v-if="formSearch.dataFilter.length > 1"
                        @click="removeFilters(index)"
                      >
                        <i class="fal fa-minus-circle fa-3x"></i>
                      </v-btn>
                      <v-btn
                        icon
                        class="px-2"
                        color="#47266f"
                        @click="addFilters"
                        :disabled="index+1 < formSearch.dataFilter.length"
                      >
                        <i class="fal fa-plus-circle fa-3x"></i>
                      </v-btn>
                    </v-card-text>
                  </div>
                </div>
              </v-card>
              <v-btn
                class="btn-step px-2"
                color="primary"
                small
                rounded
                outlined
                @click="doSearch"
                :loading="searchLoading"
              >
                Suivant
                <v-icon v-text="'$arrow_next'" small class="ml-1"></v-icon>
              </v-btn>
              <v-btn
                class="btn-step px-2"
                color="primary"
                small
                rounded
                outlined
                @click="stepFade = 2"
                v-if="stepFade > 2"
              >
                <v-icon v-text="'$arrow_back'" small class="mr-1"></v-icon>Retour
              </v-btn>
            </div>

            <v-col cols="3" class="col-result" v-if="stepFade >= 3">
              <h2
                class="step_title primary--text"
                style="text-transform: uppercase"
              >{{$t('Result')}}</h2>
              <v-card flat class="mt-0">
                <v-data-table
                  :headers="tableHeaders"
                  hide-default-footer
                  class="table-result elevation-0"
                  style="overflow-x:auto"
                >
                  <template v-slot:body="{items}">
                    <tr class v-for="(item, key) in searchResult.searchResult">
                      <td class="text-start">{{ $t(`invoiceDetailLabel.${key}`) }}</td>
                      <td class="text-start">{{ item.count }}</td>
                      <td class="text-center" style="width: 140px;">
                        <v-text-field
                          outlined
                          v-model="item.price"
                          hide-details="auto"
                          type="float"
                          min="0"
                          @change="updateTotal()"
                        ></v-text-field>
                      </td>
                      <td class="text-center">{{ item.total | round }}</td>
                    </tr>

                    <!-- Footer -->
                    <tr class="infor-table-bottom text-left">
                      <td class="text-start">Tarif HT</td>
                      <td></td>
                      <td></td>
                      <td>{{ searchResult.searchTotal.subtotal | round }}</td>
                    </tr>
                    <tr class="infor-table-bottom" v-if>
                      <td class="text-start">Discount</td>
                      <td></td>
                      <td>
                        <v-text-field
                          outlined
                          v-model="searchResult.searchTotal.discount.value"
                          hide-details="auto"
                          append-icon="fas fa-percentage"
                          placeholder="Discount percent"
                          type="number"
                          min="0"
                        ></v-text-field>
                      </td>
                      <td>{{ searchResult.searchTotal.discount.total | round }}</td>
                    </tr>
                    <tr class="infor-table-bottom">
                      <td class="text-start">Total HT</td>
                      <td></td>
                      <td></td>
                      <td>{{ searchResult.searchTotal.totalExcludeTax }}</td>
                    </tr>
                    <tr class="infor-table-bottom">
                      <td class="text-start">Total TTC</td>
                      <td></td>
                      <td>{{ searchResult.searchTotal.totalIncludeTax.percent }}</td>
                      <td>{{ searchResult.searchTotal.totalIncludeTax.total | round }}</td>
                    </tr>
                    <!-- #footer -->
                  </template>
                </v-data-table>
              </v-card>
              <div class="text-center">
                <v-btn
                  class="ma-2"
                  depressed
                  rounded
                  color="primary"
                  @click="save"
                  :loading="isSaveLoading"
                  :disabled="saveProcessing === true && isSaveLoading === false"
                >Sauvegarder</v-btn>
                <v-btn
                  class="ma-2"
                  depressed
                  rounded
                  color="#F88337"
                  @click="saveAndDownloadPdf"
                  :loading="isSavePdfLoading"
                  :disabled="saveProcessing === true && isSavePdfLoading === false"
                >
                  Sauvegarder +
                  <br />generer le devis PDF
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <AddClientForm
      v-model="dialogAddClient"
      v-on:update:item-added="onClientAdded"
      :id="editClientId"
      @add-client-search="addClient()"
    />
  </v-container>
</template>

<script>
import ClientPickerInput from "@/components/inputs/ClientPickerInput.vue";
import IdentityPickerInput from "@/components/inputs/IdentityPickerInput.vue";
import CountryMultiplePickerInput from "@/components/inputs/CountryMultiplePickerInput.vue";
import RegionMultiplePickerInput from "@/components/inputs/RegionMultiplePickerInput.vue";
import DepartmentMultiplePickerInput from "@/components/inputs/DepartmentMultiplePickerInput";
import YearMultiplePickerInput from "@/components/inputs/YearMultiplePickerInput.vue";
import SourcePickerInput from "@/components/inputs/SourcePickerInput.vue";
import NewsletterMultiplePickerInput from "@/components/inputs/NewsletterMultiplePickerInput.vue";
import ChannelMultiplePickerInput from "@/components/inputs/ChannelMultiplePickerInput.vue";
import StudyLevelMultiplePickerInput from "@/components/inputs/StudyLevelMultiplePickerInput.vue";
import DiplomaMultiplePickerInput from "@/components/inputs/DiplomaMultiplePickerInput.vue";
import ObtainedMajorMultiplePickerInput from "@/components/inputs/ObtainedMajorMultiplePickerInput.vue";
import ObtainedSpecialityMultiplePickerInput from "@/components/inputs/ObtainedSpecialityMultiplePickerInput.vue";
import ThemeCheckboxInput from "@/components/inputs/ThemeCheckboxInput.vue";
import DegreeTypePickerInput from "@/components/inputs/DegreeTypePickerInput.vue";
import SpecialityMultiplePickerInput from "@/components/inputs/SpecialityMultiplePickerInput.vue";
import AlternanceMultiplePickerInput from "@/components/inputs/AlternanceMultiplePickerInput.vue";
import SearchService from "@/services/search.service.js";
import InvoiceService from "@/services/invoice.service.js";
import AddClientForm from "@/components/forms/AddClientForm";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import NumberUtil from "../../utils/number.util";
import { mapState } from "vuex";
import { dragscroll } from "vue-dragscroll";
import ClientService from "@/services/client.service.js";
import DelegatePickerInput from "../../components/inputs/DelegatePickerInput";

export default {
  name: "Search",
  directives: {
    dragscroll
  },
  components: {
    DelegatePickerInput,
    ClientPickerInput,
    CountryMultiplePickerInput,
    RegionMultiplePickerInput,
    DepartmentMultiplePickerInput,
    ChannelMultiplePickerInput,
    SourcePickerInput,
    NewsletterMultiplePickerInput,
    StudyLevelMultiplePickerInput,
    DiplomaMultiplePickerInput,
    ObtainedMajorMultiplePickerInput,
    ObtainedSpecialityMultiplePickerInput,
    ThemeCheckboxInput,
    YearMultiplePickerInput,
    DegreeTypePickerInput,
    SpecialityMultiplePickerInput,
    AlternanceMultiplePickerInput,
    AddClientForm,
    ValidationObserver,
    ValidationProvider,
    IdentityPickerInput
  },
  computed: {
    ...mapState({
      userAuth: state => state.auth.user
    }),
    invoiceId() {
      return this.$route.params.invoiceId;
    },
    task() {
      return this.$route.params.task;
    },
    birthYearSelections: function () {
      const minAge = 16;
      const maxAge = 41;

      let arr = [];

      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let maxYear = currentYear - minAge;
      let minYear = currentYear - maxAge;

      for (let i = 1980; i <= maxYear; i++) {
        arr.push({
          text: i,
          value: i,
        });
      }

      arr.unshift({
        text: 'Avant 1980',
        value: 1979,
      });

      return arr;
    },
  },
  data() {
    return {
      fromDateVal: null,
      maxDate: new Date().toISOString().slice(0, 10),
      minDate: null,
      obtainedMajorIds: [],
      listOriginal: [],
      formClient: {
        createdAt: new Date(),
        userName: "",
        clientId: "",
        note: ""
      },
      formSearch: {},
      e1: 1,
      stepFade: 1,
      searchLoading: false,
      saveProcessing: false,
      tableHeaders: [
        {
          text: "",
          sortable: false,
          value: "name"
        },
        {
          text: "",
          sortable: false,
          value: "calories"
        },
        {
          text: "Prix U",
          align: "center",
          sortable: false,
          value: "prix"
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "total"
        }
      ],
      checkbox: false,
      searchResult: {},
      dialogAddClient: false,
      isSaveLoading: false,
      isSavePdfLoading: false,
      disabledFirstStep: false,
      taskEdit: false,
      clientContacts: [],
      clientLocations: [],
      clientName: null,
      clientContactDetail: null,
      clientLocationDetail: null,
      editClientId: null,
      idTempContact: null,
      idTempLocation: null,
      // birthYearSelections: [
      //   {
      //     text:
      //   },
      // ],
    };
  },
  created() {
    let arrName = [];
    if(this.userAuth.firstName){
      arrName.push(this.userAuth.firstName);
    }
    if(this.userAuth.lastName){
      arrName.push(this.userAuth.lastName);
    }
    this.formClient.userName = arrName.join(' ');
    this.formSearch = SearchService.getInitSearchData();
  },
  mounted() {
    if (this.invoiceId) {
      this.loadSearch();
      if (this.task == "editer") {
        this.disabledFirstStep = true;
      }
    }
  },
  methods: {
    addNewContact() {
      this.editClientId = this.formClient.clientId;
      this.dialogAddClient = true;
    },
    updateTotal() {
      let updateSubtotal = 0;
      Object.keys(this.searchResult.searchResult).forEach(item => {
        if (this.searchResult.searchResult[item]) {
          updateSubtotal +=
            this.searchResult.searchResult[item].count *
            this.searchResult.searchResult[item].price;
          this.searchResult.searchResult[item].total =
            this.searchResult.searchResult[item].count *
            this.searchResult.searchResult[item].price;
        }
      });
      this.searchResult.searchTotal.subtotal = updateSubtotal;
      this.lastTotal(this.searchResult.searchTotal.discount.value);
    },
    changeYearBackToSchool(index) {
      if (this.formSearch.dataFilter[index].yearBackToSchool.length > 0) {
        this.formSearch.dataFilter[index].createdFrom = null;
        this.formSearch.dataFilter[index].createdTo = null;
      }
    },
    changeFromDate(index) {
      this.formSearch.dataFilter[index].yearBackToSchool = [];
    },
    changeToDate(index) {
      this.formSearch.dataFilter[index].yearBackToSchool = [];
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async doSearch() {
      try {
        if (this.searchLoading) {
          return;
        }

        this.stepFade = 2;

        this.searchLoading = true;
        const { data } = await SearchService.search(this.formSearch);

        if (!data.studentIds.length) {
          this.searchResult = {};
          this.searchLoading = false;
          this.errorMessage(this.$t("No results found"));
          return;
        }

        this.searchResult = data;
        this.stepFade = 3;
      } catch (e) {
        this.handleError(e);
      }

      this.searchLoading = false;
    },
    async save() {
      this.saveProcessing = true;

      try {
        if (this.isSaveLoading || this.isSavePdfLoading) {
          return;
        }

        this.isSaveLoading = true;

        const saveObj = SearchService.getInitSaveData();

        if(this.clientContactDetail){
          this.formClient.clientContactId = this.clientContactDetail.id;
        }
        if(this.clientLocationDetail){
          this.formClient.clientLocationId = this.clientLocationDetail.id;
        }

        saveObj.searchInfo = this.formClient;
        saveObj.searchCriteria = this.formSearch;

        saveObj.searchResult = this.searchResult.searchResult;
        saveObj.searchTotal = this.searchResult.searchTotal;

        saveObj.studentIds = this.searchResult.studentIds;

        if (this.invoiceId && this.task == "editer") {
          saveObj.id = this.$route.params.invoiceId;
        }

        const { data } = await SearchService.save(saveObj);

        this.successMessage(this.$t("Search saved successfully"));
      } catch (e) {
        this.handleError(e);
      }

      this.isSaveLoading = false;
      this.saveProcessing = false;
      this.$router.push({ name: "comptages.sauvegardes" });
    },
    async saveAndDownloadPdf() {
      this.saveProcessing = true;

      try {
        if (this.isSaveLoading || this.isSavePdfLoading) {
          return;
        }

        this.isSavePdfLoading = true;
        const saveObj = SearchService.getInitSaveData();
        if(this.clientContactDetail){
          this.formClient.clientContactId = this.clientContactDetail.id;
        }
        if(this.clientLocationDetail){
          this.formClient.clientLocationId = this.clientLocationDetail.id;
        }

        saveObj.searchInfo = this.formClient;
        saveObj.searchCriteria = this.formSearch;

        saveObj.searchResult = this.searchResult.searchResult;
        saveObj.searchTotal = this.searchResult.searchTotal;

        saveObj.studentIds = this.searchResult.studentIds;

        if (this.invoiceId && this.task == "editer") {
          saveObj.id = this.$route.params.invoiceId;
        }

        // Save invoice
        const { data } = await SearchService.save(saveObj);

        // Download
        const response = await InvoiceService.downloadPdf(data.id);
        const pdfData = response.data;
        const fileName = response.fileName;

        const url = window.URL.createObjectURL(new Blob([pdfData]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        this.successMessage(this.$t("Search saved successfully"));
      } catch (e) {
        this.handleError(e);
      }

      this.isSavePdfLoading = false;
      this.saveProcessing = false;
      this.$router.push({ name: "comptages.sauvegardes" });
    },
    goStep2() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.stepFade = 2;
      });
    },
    backToStep1() {
      this.stepFade = 1;
      this.formSearch = SearchService.getInitSearchData();
    },
    onClientAdded(id) {
      this.$refs.clientPickerInput.loadListItem();

      this.formClient.clientId = id;
    },
    addFilters() {
      this.formSearch.dataFilter.push(SearchService.getInitFilter());
    },
    removeFilters(index) {
      if (this.formSearch.dataFilter.length > 1) {
        this.formSearch.dataFilter.splice(index, 1);
      }
    },
    async loadSearch() {
      const loadSearch = await SearchService.loadSearch(this.invoiceId);
      const searchData = JSON.parse(loadSearch.data.searchData);
      this.taskEdit = true;
      this.formSearch.dataSearch = searchData.dataSearch;
      this.formSearch.dataFilter = searchData.dataFilter;
      this.formClient.userName = loadSearch.data.userName;
      this.formClient.clientId = loadSearch.data.clientId;
      this.formClient.note = loadSearch.data.note;
      this.searchResult = loadSearch.data.searchResult;

      if (loadSearch.data.clientContactId) {
        this.idTempContact = loadSearch.data.clientContactId;
      }

      if (loadSearch.data.clientLocationId) {
        this.idTempLocation = loadSearch.data.clientLocationId;
      }

      if (loadSearch.data.identityId) {
        this.formClient.identityId = loadSearch.data.identityId;
      }

      setTimeout(() => {
        this.stepFade = 2;
        this.searchLoading = true;
        this.stepFade = 3;
        this.searchLoading = false;
      }, 500);
    },
    resetTask() {
      this.taskEdit = false;
    },
    lastTotal(discountPercent) {
      discountPercent = Number(discountPercent) || 0;

      const subtotal = this.searchResult.searchTotal.subtotal;

      // Discount amount
      const discountTotal = NumberUtil.round(
        (subtotal * discountPercent) / 100,
        2
      );
      const discountText = `${discountPercent}%`;

      // Total exclude tax
      const totalExcludeTax = NumberUtil.round(subtotal - discountTotal, 2);

      // Total include tax
      const taxNumber =
        Number(this.searchResult.searchTotal.totalIncludeTax.value) || 0;
      const totalIncludeTax = NumberUtil.round(
        totalExcludeTax + (totalExcludeTax * taxNumber) / 100,
        2
      );

      // Map value
      this.searchResult.searchTotal.discount.total = discountTotal;
      this.searchResult.searchTotal.discount.percent = discountText;
      this.searchResult.searchTotal.totalExcludeTax = totalExcludeTax;
      this.searchResult.searchTotal.totalIncludeTax.total = totalIncludeTax;
    },
    async addClient() {
      const client = await ClientService.getById(this.formClient.clientId);

      if (client.data.clientContacts) {
        this.clientContacts = client.data.clientContacts;
      }

      if (client.data.clientLocations) {
        this.clientLocations = client.data.clientLocations;
      }
    }
  },
  watch: {
    "searchResult.searchTotal.discount.value": {
      handler(discountPercent) {
        if (discountPercent == "undefined") {
          return;
        }
        this.lastTotal(discountPercent);
      }
    },
    "formClient.clientId": {
      async handler(clientId) {
        const client = await ClientService.getById(clientId);
        if (client.data.clientContacts) {
          this.clientContacts = client.data.clientContacts;
        }

        if (client.data.clientLocations) {
          this.clientLocations = client.data.clientLocations;
        }

        if (this.idTempContact) {
          this.clientContactDetail = this.clientContacts.find(
            u => u.id == this.idTempContact
          );
        }

        if (this.idTempLocation) {
          this.clientLocationDetail = this.clientLocations.find(
            u => u.id == this.idTempLocation
          );
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
